import { useCallback, useLayoutEffect, useRef } from 'react'
import { Button, ButtonIconSizes, IconPositions } from 'atoms/Button'
import { IconNames } from 'atoms/Icon/Icon.h'
import { TextBoxMaxLine4FontSm } from 'atoms/TextBox/Templates'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { PAGE_NOTIFICATION } from 'vars/navbar'
import { TopPageNotificationSC } from './TopPageNotification.styled'

interface TopPageNotificationProps {
  children: React.ReactNode
  onClose: () => void
}

export const TopPageNotification = ({
  children,
  onClose,
}: TopPageNotificationProps) => {
  const notificationRef = useRef<HTMLDivElement>(null)

  const setNotificationHeight = useCallback((height: number) => {
    document.documentElement.style.setProperty(
      PAGE_NOTIFICATION.HEIGHT,
      `${height}px`
    )
  }, [])

  useLayoutEffect(() => {
    const element = notificationRef.current
    if (!element) {
      setNotificationHeight(0)
      return
    }

    const updateHeight = () => {
      const height = element.offsetHeight
      setNotificationHeight(height)
    }

    updateHeight()

    const resizeObserver = new ResizeObserver(updateHeight)
    resizeObserver.observe(element)

    return () => {
      resizeObserver.disconnect()
      setNotificationHeight(0)
    }
  }, [setNotificationHeight])

  const handleClose = () => {
    onClose()
    setNotificationHeight(0)
  }

  return (
    <TopPageNotificationSC ref={notificationRef}>
      <TextBoxMaxLine4FontSm>{children}</TextBoxMaxLine4FontSm>

      <Button
        onClick={handleClose}
        icon={IconNames.close}
        iconSize={ButtonIconSizes.mSm}
        iconPosition={IconPositions.Center}
        paddings={[
          FIXED_INDENTS.INDENT_20,
          FIXED_INDENTS.INDENT_20,
          FIXED_INDENTS.INDENT_20,
          FIXED_INDENTS.INDENT_20,
        ]}
      />
    </TopPageNotificationSC>
  )
}
